import { AttioValuationFilter } from 'dashboard409a/common/constants/analyst-dashboard';
import { AttioBulkService } from './AttioBulkService';
import { attioService } from './AttioService';
import { AttioValuationService } from './AttioValuationService';

const valuationService = new AttioValuationService();
const bulkService = new AttioBulkService();

export const getAllAttioValuationsWithBulkData = (params: {
  userRecordId: string;
  filters: AttioValuationFilter;
  searchParams: {
    searchParam: string;
    searchAll: boolean;
  };
  groupByDeals?: boolean;
}) =>
  valuationService.getAllValuationsWithBulkData({
    ...params,
    groupByDeals: params.groupByDeals ?? false,
  });

export const loadBulkConsultants = (consultantIds: string[], signal?: AbortSignal) =>
  bulkService.loadBulkConsultants(consultantIds, signal);

export const loadBulkValuations = (valuationIds: string[], signal?: AbortSignal) =>
  bulkService.loadBulkValuations(valuationIds, signal);

export const getValuationStatusOptions = () => attioService.status.getValuationStatusOptionsLegacy();

export const updateValuationStatus = (
  valuationId: string,
  statusOptionId: string,
  valuationDetail?: Record<string, unknown>,
  companyName?: string
) => attioService.status.updateValuationStatus({ valuationId, statusOptionId, valuationDetail, companyName });

export const updateValuationDealStage = (dealId: string, dealStageOptionId: string, companyName?: string) =>
  attioService.deals.updateValuationDealStage({ dealId, dealStageOptionId, companyName });

export const getAttioUserRecordId = (userEmail: string) => attioService.users.getUserRecordIdLegacy(userEmail);

export const getDealStatusOptions = () => attioService.deals.getDealStatuses();

export const sendFinalInvoice = (dealId: string, companyName?: string) =>
  attioService.deals.sendFinalInvoice(dealId, companyName);

export const getAttioValuationDetail = (valuationRecordId: string) =>
  attioService.valuationDetails.getValuationDetail(valuationRecordId);

export const getAttioNotesForValuation = (
  records: Array<{ parentObject: string; parentRecordId: string; prefix: string }>
) => attioService.notes.getNotesForValuation(records);
